@let currentDay = currentDay$ | async;
<div class="w-full grid grid-cols-7 gap-2 place-content-center">
  @if (tinyHeader) {
    <div class="tiny">{{ currentDay.format('dddd') }}, {{ currentDay.format('LL') }}</div>
  } @else {
    @for (date of datesArr(); track $index) {
      <div
        class="flex flex-col items-center py-3 rounded"
        [class.active]="isActive(date, currentDay)"
        (click)="setCurrentDay.emit(date)"
      >
        <div class="day capitalize text-white/70">
          {{ date.format('dddd').substring(0, 2) }}
        </div>
        <div class="numb text-white">{{ date.date() }}</div>
      </div>
    }
  }
</div>
